import PadMarginCenter from './PadMarginCenter';
import { PadMarginCenterProps, PadMarginCenterValueProps } from './types';

export type { PadMarginCenterProps, PadMarginCenterValueProps };
export default PadMarginCenter;
